import {LevelLoader} from "./levelloader";
import {Player} from "./player";
import Tilemap = Phaser.Tilemap;
import Point = Phaser.Point;
import game = PIXI.game;
import Key = Phaser.Key;
import {Texter} from "./texter";
/**
 * Represents the PlayState
 */


var layerinthTitle;
var mainMenuButton, reloadButoon;
var buttonleft, buttonright, buttonup, buttondown, buttonlayerup, buttonlayerdown;
var imageKey;
var key: boolean = false;
var left, right, up, down, layerup, layerdown = false;
export class PlayState extends Phaser.State {
    texter: Texter;
    cursors: Phaser.CursorKeys;
    levelloader: LevelLoader;
    player: Player;
    aKey: Key;
    yKey: Key;
    currentLevel: number;
    haveKey: boolean = false;

    init(level: number) {
        this.currentLevel = level;
    }

    preload() {
        console.log("create PlayState");
        this.cursors = this.game.input.keyboard.createCursorKeys();
        this.aKey = this.game.input.keyboard.addKey(Phaser.Keyboard.A);
        this.yKey = this.game.input.keyboard.addKey(Phaser.Keyboard.Y);

        this.texter = new Texter(this.game);
        this.levelloader = new LevelLoader(this.game);
        this.levelloader.initGridTiles();
        this.levelloader.initLevels();

    }

    create() {
        layerinthTitle = this.game.add.sprite(this.game.width/2 -133,20, 'layerinth');
        this.levelloader.loadLevel(this.currentLevel);
        this.levelloader.loadLayer(0);
        let startTile = this.levelloader.getTile(this.levelloader.levelList[this.currentLevel].start.x, this.levelloader.levelList[this.currentLevel].start.y,0);
        this.player = new Player(this.game, this.levelloader, this.texter);
        this.player.loadNewLevel(startTile);
        this.texter.render("Use Up, Down, Left, Right, A, Y to move.", this.game.width/2 -190, 535);

        this.game.add.image(this.game.width/2 -190, 555, 'levelname'+this.currentLevel,1);

        //DISPLAY IF YOU HAVE A KEY
        imageKey = this.game.add.image(this.game.width/2 -60, 550, 'key',1);

        mainMenuButton = this.game.add.button(this.game.width/2 +115, 555, 'menuButton',this.loadMenu, this, 2, 1, 0);
        reloadButoon = this.game.add.button(this.game.width/2 +34, 555, 'reloadButton', this.reloadLevel, this, 2, 1, 0);


        // Aktion für Flug nach rechts
        buttonright = this.game.add.button(this.game.width/2 + 3, 480, 'buttonright', null, this, 0, 1, 0, 1);
        buttonright.events.onInputDown.add(function(){right=true;});

// Aktion für Flug nach links
        buttonleft = this.game.add.button(this.game.width/2 - 45, 480, 'buttonleft', null, this, 0, 1, 0, 1);
        buttonleft.events.onInputDown.add(function(){left=true;});

// Aktion für Flug nach oben
        buttonup = this.game.add.button(this.game.width/2 -190, 480, 'buttonup', null, this, 0, 1, 0, 1);
        buttonup.events.onInputDown.add(function(){up=true;});

// Aktion für Flug nach unten
        buttondown = this.game.add.button(this.game.width/2 -142, 480, 'buttondown', null, this, 0, 1, 0, 1);
        buttondown.events.onInputDown.add(function(){down=true;});


        buttonlayerup = this.game.add.button(this.game.width/2 + 147, 480, 'buttonlayerdown', null, this, 0, 1, 0, 1);
        buttonlayerup.events.onInputDown.add(function(){layerdown=true;});

        buttonlayerdown = this.game.add.button(this.game.width/2 + 99, 480, 'buttonlayerup', null, this, 0, 1, 0, 1);
        buttonlayerdown.events.onInputDown.add(function(){layerup=true;});
    }


    update() {
        let target = new Point(this.player.currentTile.x, this.player.currentTile.y);
        let targetLayer = this.levelloader.currentLayer;

        if (this.player.won) {
            //HERE GOES CODE WHEN GAME IS WON
            this.game.world.removeAll();
            this.game.state.start('LevelCompleteState', true, false, this.currentLevel);
            return;
        }
        if (this.cursors.down.justDown || down) {
            down = false;
            target = new Point(this.player.currentTile.x, this.player.currentTile.y + 1);
            this.player.move(target, targetLayer);
            return;
        }
        if (this.cursors.up.justDown || up) {
            up = false;
            target = new Point(this.player.currentTile.x, this.player.currentTile.y - 1);
            this.player.move(target, targetLayer);
            return;
        }
        if (this.cursors.left.justDown || left) {
            left = false;
            target = new Point(this.player.currentTile.x - 1, this.player.currentTile.y);
            this.player.move(target, targetLayer);
            return;
        }
        if (this.cursors.right.justDown || right) {
            right = false;
            target = new Point(this.player.currentTile.x + 1, this.player.currentTile.y);
            this.player.move(target, targetLayer);
            return;
        }
        if (this.aKey.justDown || layerup) {
            layerup = false;
            targetLayer++;
            this.player.move(target, targetLayer);
            return;
        }
        if (this.yKey.justDown || layerdown) {
            layerdown = false;
            targetLayer--;
            this.player.move(target, targetLayer);
            return;
        }

        if(this.haveKey != this.player.key){
            this.haveKey=this.player.key;
            if(this.haveKey){
                imageKey.destroy();
                imageKey = this.game.add.image(this.game.width/2 -60, 550, 'key',0);//0=key, 1=nokey
            } else {
                imageKey.destroy();
                imageKey = this.game.add.image(this.game.width / 2 - 60, 550, 'key', 1);//0=key, 1=nokey
            }
        }
    }

    loadMenu(){
        this.game.world.removeAll();
        this.game.state.start('MenuState', true, false);
    }

    reloadLevel(){
        this.game.world.removeAll();
        this.create();
    }
}


// WEBPACK FOOTER //
// ./src/playstate.ts